module.exports = __webpack_public_path__ + "static/phone-slide-6-73120baf8a6bc8bf35eeec14f0d97469.png";